import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';

import { FuseDirectivesModule } from '@fuse/directives/directives';
import { FusePipesModule } from '@fuse/pipes/pipes.module';
import { MaterialModule } from './material.module';
import { TranslateModule } from '@ngx-translate/core';
import { GravatarModule, GravatarConfig, RATING } from 'ngx-gravatar';
import { InputDialogComponent } from 'app/main/content/global-component/input-dialog/input-dialog.component';
import { FuseConfirmDialogModule } from './components';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { GlobalPipesModule } from 'app/main/content/pipes/globalPipes.module';

const gravatarConfig: GravatarConfig = {
    rating: RATING.pg,
    fallback: 'mp'
};
  

@NgModule({
    imports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        FuseDirectivesModule,
        FusePipesModule,

        MaterialModule,
        GravatarModule.forRoot(gravatarConfig),
        TranslateModule,
        CKEditorModule,
        FuseConfirmDialogModule,
        GlobalPipesModule
    ],
    declarations: [
        InputDialogComponent,
    ],
    entryComponents: [
        InputDialogComponent
    ],
    exports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        FuseDirectivesModule,
        FusePipesModule,
        MaterialModule,
        GravatarModule,
        TranslateModule,
        CKEditorModule,
        InputDialogComponent,
        FuseConfirmDialogModule,
        GlobalPipesModule
    ]
})
export class FuseSharedModule
{
}
